var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-scroll", style: _vm.scrollStyle },
    [
      _c(
        "div",
        {
          ref: "view",
          staticClass: "v-scroll__wrap",
          style: _vm.wrapStyle,
          on: { scroll: _vm.scroll },
        },
        [_vm._t("default")],
        2
      ),
      _vm.isVertical
        ? _c("bar", {
            ref: "ybar",
            style: { visibility: _vm.isMac ? "hidden" : "visible" },
            attrs: {
              direct: "y",
              barsize: _vm.vbarHeight,
              sliderWidth: _vm.sliderWidth,
            },
            on: { change: _vm.change },
            model: {
              value: _vm.scrollTop,
              callback: function ($$v) {
                _vm.scrollTop = $$v
              },
              expression: "scrollTop",
            },
          })
        : _vm._e(),
      _vm.isHorizontal
        ? _c("bar", {
            ref: "xbar",
            style: { visibility: _vm.isMac ? "hidden" : "visible" },
            attrs: {
              direct: "x",
              barsize: _vm.hBarWidth,
              sliderWidth: _vm.sliderWidth,
            },
            on: { change: _vm.change },
            model: {
              value: _vm.scrollLeft,
              callback: function ($$v) {
                _vm.scrollLeft = $$v
              },
              expression: "scrollLeft",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }